import React from 'react';
import { Button as AntButton, Dropdown as AntDropdown } from 'antd';
import './Dropdown.scss';

interface IProps {
  text?: string;
  type?: 'primary' | 'text' | 'link' | 'ghost' | 'default' | 'dashed';
  className?: string;
  items?: any;
  onClick?: () => void;
}

export const Dropdown = (props: IProps) => {
  const { items, type = 'primary', text, className } = props;

  return (
    <AntDropdown menu={{ items }} placement="bottomRight" arrow={{ pointAtCenter: true }}>
      <AntButton type={type} className={`inital ${className}`}>
        {text}
      </AntButton>
    </AntDropdown>
  );
};
